import React, {Component} from "react"

import {Entity} from "aframe-react" 

import Quicksand from "../assets/fonts/quicksand.fnt"
import QuicksandSheet from "../assets/fonts/quicksand.png"

import FadeAnimation from "../components/FadeAnimation"

class NavButton extends Component {

    constructor(props) {
        super(props)

        this.btnMaterial = {
            shader: "flat", 
            transparent: true,
        }
    }

    render() {
        return (
            <Entity
                geometry={{primitive: "circle", radius: this.props.radius}}

                position={this.props.position}
                material={{ ...this.btnMaterial, src: this.props.src }}

                events={{
                    clickUp: () => this.props.click(),

                    mouseenter: (e) => {
                        console.log(this.txt.el)
                        this.txt.el.emit("txtenter")
                    },

                    mouseleave: (e) => {
                        this.txt.el.emit("txtleave")
                    }
                }} 

                frame-button={{ button: true, }}
            >
                <Entity 
                    ref={ (i) => { this.txt = i } }

                    primitive="a-text"

                    position={{x: 0, y: 0.6, z: 0}}
                    scale={{x: this.props.size, y: this.props.size, z: 1}}

                    value={this.props.text.toUpperCase()}

                    color="#F5A623"

                    text={{
                        font: Quicksand,
                        fontImage: QuicksandSheet,
                        opacity: 0,
                    }}

                    align="center"
                >
                    <FadeAnimation
                        attribute="text.opacity"
                        min="0"
                        dur={400}

                        begin={"txtenter"}
                        end={"txtleave"}
                    />
                    <FadeAnimation
                        attribute="text.opacity"
                        min="0"
                        dur={400}

                        begin={"txtenter"}
                        end={"txtleave"}

                        reverse={true}
                    />
                </Entity>

                <FadeAnimation 
                    attribute="scale"
                    dur={400}
                    min="1 1 1" max="1.2 1.2 1"
                />
                <FadeAnimation 
                    attribute="scale"
                    dur={400}
                    min="1 1 1" max="1.2 1.2 1"
                    reverse={true}
                />

            </Entity>
        )
    }
}

NavButton.defaultProps = {

    position: {x: 0, y: 0, z: 0.1},
    radius: 0.4,

    size: 0.8,

    text: "Hello",

}

export default NavButton


// WEBPACK FOOTER //
// ./src/components/NavButton.js